import { create } from 'zustand';

interface AppState {
  sidebarOpen: boolean;
  currentUser: {
    prenom: string;
    nom: string;
    email: string;
    plan: 'starter' | 'pro' | 'enterprise';
    avatar?: string;
  };
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
}

export const useAppStore = create<AppState>((set) => ({
  sidebarOpen: true,
  currentUser: {
    prenom: 'Aziz',
    nom: 'Ben Salah',
    email: 'aziz@automarket.tn',
    plan: 'pro',
  },
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
}));
